<div class="onboarding">
    <div class="semi-background">
        <div class="col-md-10 mx-auto">
            <token-header></token-header>

            <div class="content mt-0 mt-md-3">
                <div class="animate__animated animate__slideInRight token-content">
                    <div>
                        <h4 class="text-center">{{ 'onboarding.token.renewed_token.title' | translate}} <br> {{ 'onboarding.token.renewed_token.title_bis' | translate}}</h4>
                        <p class="text-center">{{ 'onboarding.token.renewed_token.description' | translate}}</p>
                        <img class="email-img" src="/assets/images/registration/email.gif">
                        <p class="text-center email-note"><b>{{ 'onboarding.token.renewed_token.note' | translate}}</b> {{ 'onboarding.token.renewed_token.note_bis' | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
